export interface LosAuthResponseModel {
    access_token: string;
}